import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import useStudentEvaluationService from "../../api/services/StudentEvaluationService";
import { toast } from "react-hot-toast";

const DeleteDialog = ({ open, onClose, deletingData, onSuccess }) => {
  const { deleteEvaluationById } = useStudentEvaluationService();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    if (!deletingData?.originalData?.id) {
      toast.error("Evaluation ID is missing");
      return;
    }

    try {
      setIsLoading(true);
      await deleteEvaluationById(deletingData.originalData.id);
      toast.success("Student evaluation deleted successfully");
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Error deleting evaluation:", error);
      // Error toast is already handled in the service
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="error" />
          <Typography variant="h6">Confirm Delete</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This action cannot be undone. The student evaluation will be permanently deleted.
        </Alert>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this student evaluation?
        </Typography>
        {deletingData && (
          <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Term:</strong> {deletingData.termName || deletingData.originalData?.term?.termName || "N/A"}
            </Typography>
            {deletingData.originalData && (
              <>
                {deletingData.originalData.spiritualLife && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    <strong>Spiritual Life:</strong> {deletingData.originalData.spiritualLife}
                  </Typography>
                )}
                {deletingData.originalData.academicLife && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    <strong>Academic Life:</strong> {deletingData.originalData.academicLife}
                  </Typography>
                )}
              </>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;

